import ServiceUC from '../../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceUC {
  constructor() {
    super('/api/cdr-report');
  }

  async getReportById(id) {
    return this.get(id);
  }

  async getReportByUniqueId(id) {
    return this.get(`unique-id/${id}`);
  }
}

export default new Service();
